// Request Type Constants
export const REQUEST_TYPES = {
  ADD_UNAVAILABLE_STATUS: "Add Unavailable Status",
  MODIFY_UNAVAILABLE_STATUS: "Modify Unavailable Status",
  REMOVE_UNAVAILABLE_STATUS: "Remove Unavailable Status",
  REMOVE_DELIVERY_RESTRICTION: "Remove Delivery Restriction",
  LENDER_ADD_PROJECT: "Lender Add Project",
  LENDER_ADD_PHASE: "Lender Add Phase",
  LENDER_EDIT_PROJECT: "Lender Edit Project",
  LENDER_EDIT_PHASE: "Lender Edit Phase",
};
